import { client } from "api";
import { Department } from "models/Department";

export type UpdateDepartmentRequest = { id: number; name: string; };

export type UpdateDepartmentResponse = Department[];

export const updateDepartment = ({ id, ...data }: UpdateDepartmentRequest) =>
  client.put<UpdateDepartmentResponse>(`/department/${id}`, data).then((res) => res.data);
